/* tslint:disable */
/* eslint-disable */
/**
 * Admin Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PagedModelRoleDTO,
} from '../models/index';
import {
    PagedModelRoleDTOFromJSON,
    PagedModelRoleDTOToJSON,
} from '../models/index';

export interface GetDistinctRolesRequest {
    page?: number;
    size?: number;
    sort?: string;
}

/**
 * 
 */
export class RoleServiceApi extends runtime.BaseAPI {

    /**
     * Creates request options for getDistinctRoles without sending the request
     */
    async getDistinctRolesRequestOpts(requestParameters: GetDistinctRolesRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/role/distinct`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getDistinctRolesRaw(requestParameters: GetDistinctRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedModelRoleDTO>> {
        const requestOptions = await this.getDistinctRolesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PagedModelRoleDTOFromJSON(jsonValue));
    }

    /**
     */
    async getDistinctRoles(requestParameters: GetDistinctRolesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedModelRoleDTO> {
        const response = await this.getDistinctRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
